import { render, staticRenderFns } from "./OrderStatusScannerDrawer.vue?vue&type=template&id=5d478147&scoped=true&"
import script from "./OrderStatusScannerDrawer.vue?vue&type=script&lang=js&"
export * from "./OrderStatusScannerDrawer.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusScannerDrawer.vue?vue&type=style&index=0&id=5d478147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d478147",
  null
  
)

export default component.exports